import type {
  CollectionActions,
  CollectionStateSlice,
} from '@freelancer/datastore/core';
import {
  mergeDocuments,
  transformIntoDocuments,
} from '@freelancer/datastore/core';
import type { PackageApi } from 'api-typings/memberships/memberships_types';
import { transformMembershipPackage } from './membership-packages.transformers';
import type { MembershipPackagesCollection } from './membership-packages.types';

export function membershipPackagesReducer(
  state: CollectionStateSlice<MembershipPackagesCollection> = {},
  action: CollectionActions<MembershipPackagesCollection>,
): CollectionStateSlice<MembershipPackagesCollection> {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (action.payload.type === 'membershipPackages') {
        const { result, ref, order } = action.payload;
        return mergeDocuments<MembershipPackagesCollection>(
          state,
          transformIntoDocuments(
            result.reduce<readonly PackageApi[]>(
              (prev, curr) => prev.concat(curr.packages),
              [],
            ),
            transformMembershipPackage,
          ),
          order,
          ref,
        );
      }
      return state;
    }
    default:
      return state;
  }
}
